import Vue from 'vue'

const searchByZip = (zip) => {
  return Vue.prototype.$http.get('offices', { params: { zip } })
}

const fetchOne = (id) => {
  return Vue.prototype.$http.get(`offices/${id}`)
}

export default {
  searchByZip,
  fetchOne,
}
